import React, { useCallback, useState } from "react";
import CollapseItem from "./CollapseItem";
import styles from "./styles.module.css";

const Collapse = ({
  items,
  defaultActive,
  multiSelect,
  containerStyles,
  itemStyles,
  headerStyles,
  contentStyles,
}) => {
  const [activeKey, setActiveKey] = useState(multiSelect ? defaultActive : []);

  const handleToggle = useCallback((key) => {
    if (multiSelect) setActiveKey((prevKey) => (prevKey === key ? null : key));
    else
      setActiveKey((prevKeys) =>
        prevKeys?.includes(key)
          ? prevKeys?.filter((item) => item !== key)
          : [...prevKeys, key]
      );
  }, []);

  return (
    <div className={`${styles["collapse-container"]} ${containerStyles || ""}`}>
      {items?.map((item) => (
        <CollapseItem
          key={item.key}
          item={item}
          isActive={activeKey?.includes(item.key)}
          onToggle={handleToggle}
          itemStyles={itemStyles}
          headerStyles={headerStyles}
          contentStyles={contentStyles}
        />
      ))}
    </div>
  );
};

export default Collapse;
